export default "__VITE_ASSET__BpjAT3gX__"